export const categories = [
  {
    slug: "yule",
    name: "娱乐八卦",
    tagline: "艺人动态与圈内传闻",
    description:
      "追踪影视歌三栖艺人的公开行程、作品动向与圈内热议，把零散的爆料线索整理成有前后脉络的事件记录。",
    cover:
      "https://readdy.ai/api/search-image?query=stylized%20abstract%20entertainment%20news%20scene%20with%20neon%20spotlight%20beams%20and%20glowing%20stage%20silhouettes%2C%20warm%20coral%20and%20amber%20tones%2C%20editorial%20magazine%20collage%20texture%2C%20soft%20grain%2C%20cinematic%20mood&width=800&height=500&seq=chigua-cat-yule-01&orientation=landscape",
    count: 6,
    icon: "ri-mic-line",
  },
  {
    slug: "shehui",
    name: "社会奇闻",
    tagline: "城市里的新鲜事",
    description:
      "记录街头巷尾被网友反复讨论的生活奇事、城市见闻与公共话题，还原事情发生的场景与后续进展。",
    cover:
      "https://readdy.ai/api/search-image?query=stylized%20abstract%20night%20city%20street%20scene%20with%20glowing%20windows%20and%20long%20exposure%20light%20trails%2C%20teal%20green%20and%20warm%20cream%20color%20palette%2C%20editorial%20documentary%20poster%20style%2C%20soft%20film%20grain&width=800&height=500&seq=chigua-cat-shehui-02&orientation=landscape",
    count: 4,
    icon: "ri-building-line",
  },
  {
    slug: "wanghong",
    name: "网红动态",
    tagline: "直播与短视频圈风波",
    description:
      "直播、短视频与带货圈的最新动态，包含涨粉冲刺、合作变动与网友争议，按时间线梳理来龙去脉。",
    cover:
      "https://readdy.ai/api/search-image?query=stylized%20abstract%20live%20streaming%20studio%20scene%20with%20ring%20light%20glow%20and%20floating%20notification%20bubbles%2C%20coral%20pink%20and%20amber%20gradient%20lighting%2C%20modern%20editorial%20poster%20style%2C%20clean%20minimal%20composition&width=800&height=500&seq=chigua-cat-wanghong-03&orientation=landscape",
    count: 4,
    icon: "ri-live-line",
  },
  {
    slug: "yingshi",
    name: "影视综",
    tagline: "剧集综艺话题走势",
    description:
      "热播剧集、电影与综艺的看点分析与话题走向，包含播出数据、名场面讨论与观众口碑变化。",
    cover:
      "https://readdy.ai/api/search-image?query=stylized%20abstract%20cinema%20screen%20scene%20with%20dramatic%20light%20rays%20and%20film%20strip%20texture%2C%20deep%20red%20and%20golden%20amber%20tones%2C%20retro%20movie%20poster%20aesthetic%2C%20soft%20vignette&width=800&height=500&seq=chigua-cat-yingshi-04&orientation=landscape",
    count: 4,
    icon: "ri-film-line",
  },
  {
    slug: "qinglv",
    name: "情侣纪事",
    tagline: "恋爱传闻与婚讯梳理",
    description:
      "围绕恋情曝光、同框路透、婚讯与分手传闻的话题整理，标注信息时间点与官方回应状态。",
    cover:
      "https://readdy.ai/api/search-image?query=stylized%20abstract%20romantic%20sunset%20scene%20with%20two%20blurred%20silhouettes%20and%20bokeh%20lights%2C%20warm%20peach%20coral%20and%20golden%20color%20grading%2C%20soft%20dreamy%20editorial%20style%2C%20gentle%20film%20grain&width=800&height=500&seq=chigua-cat-qinglv-05&orientation=landscape",
    count: 4,
    icon: "ri-heart-3-line",
  },
];

